import React from 'react'
import { MultiSelect } from 'react-multi-select-component'
import Label from './Label'
import ErrorMessage from './ErrorMessage'

export default function ReactMultiSelect({
  error,
  label,
  onChange = () => {},
  options,
  placeholder = 'Select',
  value,
  disabled,
  hasSelectAll,
  disableSearch,
  limitDisplayedItems,
  useSeparator = true,
  inlineDropdown = false,
}) {

  const customValueRenderer = (selected, _options) => {
    // If no items selected, return undefined to show placeholder
    if (!selected || selected.length === 0) {
      return undefined;
    }

    if (!limitDisplayedItems || selected.length <= limitDisplayedItems) {
      return (
        <div className="flex flex-wrap gap-1">
          {selected.map((item, index) => (
            <span key={index} className="bg-rb-green text-white p-1 rounded-md text-sm">
              {item.label}
            </span>
          ))}
        </div>
      );
    }

    const displayedItems = selected.slice(0, limitDisplayedItems);
    const additionalCount = selected.length - limitDisplayedItems;

    return (
      <div className="flex flex-wrap gap-1 items-center">
        {displayedItems.map((item, index) => (
          <span key={index} className="bg-rb-green text-white p-1 rounded-md text-sm">
            {item.label}
          </span>
        ))}
        <span className="bg-rb-green text-white p-1 rounded-md text-sm font-medium">
          +{additionalCount}
        </span>
      </div>
    );
  };
  // Új valueRenderer a space elválasztóval
  const spaceSeparatorValueRenderer = (selected, _options) => {
    if (!selected || selected.length === 0) {
      return undefined;
    }

    return (
      <div className="flex flex-wrap items-center">
        {selected.map((item, index) => (
          <React.Fragment key={index}>
            <span className="p-1 rounded-md text-sm">
              {item.label}
            </span>
            {index < selected.length - 1 && (
              <span className="mx-1 text-gray-600">{useSeparator ? "," : " "}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };
  return (
    <>
      <p className='font-medium ml-2 dark:text-rb-dark-mode-text-light'>{label}</p>

      <div className={`${error ? "error" : ""} ${inlineDropdown ? "rb-inline-dropdown" : ""}`}>
        <MultiSelect
          labelledBy={placeholder}
          onChange={onChange}
          options={options}
          value={value}
          disabled={disabled}
          hasSelectAll={hasSelectAll}
          disableSearch={disableSearch}
          placeholder={placeholder}
          valueRenderer={limitDisplayedItems ? customValueRenderer : undefined}
          overrideStrings={{ "selectSomeItems": placeholder }}
        />
      </div>
      {
        error && <ErrorMessage text={error} />
      }
    </>
  );
}
